import React, {useState} from "react";
import AuthService from "../Services/auth.service";

const Profile =(props)=> {
  const currentUser=useState(AuthService.getCurrentUser());
    console.log(currentUser)
    return (
        <div className="container-fluid">
        <header className="jumbotron">
            <h3>
            <strong>{currentUser[0].username}</strong> Profile
            </h3>
        </header>
        <div className="jumbotron">
            <p>
                <strong>Token:</strong>
                <div>{currentUser[0].accessToken}</div>
                <div>{currentUser[0].password}</div>
            </p>
            <p>
                <strong>Id:</strong>
                {currentUser[0].id}
            </p>
            <strong>Authorities:</strong>
            <ul>
                {currentUser[0].roles}
                {/*currentUser.roles && currentUser.roles.map((role, index) => <li key={index}>{role}</li>)*/}
            </ul>
        </div>
        </div>
    );
}

export default Profile;